<template>
  <v-dialog v-model="mostrado" persistent scrollable max-width="1200px">
    <v-form ref="form" @submit.prevent="guardar">
      <v-card>
        <v-card-title class="pt-2 pb-0">REGISTRAR COMPROBANTE DE REVERSIÓN</v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12">
              <p class="subtitle-2 mb-1">Detalles seleccionados ({{ detalles.length }})</p>
              <v-simple-table dense class="mb-3">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Clasificador</th>
                    <th>Sede Origen</th>
                    <th>Banco Origen</th>
                    <th>Cuenta Origen</th>
                    <th class="text-right">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in detalles" :key="detalle.id">
                    <td class="caption">{{ detalle.id }}</td>
                    <td class="caption">
                      <span v-if="detalle.clasificador">
                        {{ detalle.clasificador.codigo }} - {{ detalle.clasificador.nombre }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="caption">{{ detalle.sede_origen || '-' }}</td>
                    <td class="caption">{{ detalle.banco_origen || '-' }}</td>
                    <td class="caption">{{ detalle.cuenta_origen || '-' }}</td>
                    <td class="caption text-right">{{ Number(detalle.importe || 0).toFixed(2) }}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="text-right font-weight-bold caption">Total:</td>
                    <td class="text-right font-weight-bold caption">{{ totalDetalles }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>

            <v-col cols="12" lg="7">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="detalles[0].sede_destino"
                    label="Sede Destino"
                    outlined
                    dense
                    hide-details
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="detalles[0].banco_destino"
                    label="Banco Destino (para validar el comprobante)"
                    outlined
                    dense
                    hide-details
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="detalles[0].cuenta_destino"
                    label="Cuenta Destino (para validar el comprobante)"
                    outlined
                    dense
                    hide-details
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="importe"
                    label="Importe (verificación)"
                    type="number"
                    step="0.01"
                    min="0"
                    outlined
                    dense
                    clearable
                    :rules="[
                      (v) => !!v || 'El importe es requerido',
                      (v) =>
                        Number(v).toFixed(2) === Math.abs(Number(totalDetalles)).toFixed(2) ||
                        `El importe (${Number(v || 0).toFixed(2)}) no coincide con el total de los detalles (${Math.abs(
                          Number(totalDetalles),
                        ).toFixed(2)})`,
                    ]"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.numero_comprobante"
                    label="Número de Comprobante"
                    outlined
                    dense
                    clearable
                    :rules="[(v) => !!v || 'El número de comprobante es requerido']"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="form.fecha_hora"
                    type="datetime-local"
                    label="Fecha y Hora"
                    :max="maxFechaHora"
                    outlined
                    dense
                    clearable
                    :rules="[(v) => !!v || 'La fecha y hora es requerida']"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    v-model="archivo"
                    label="Adjuntar Comprobante (JPG, PNG, PDF)"
                    accept="image/jpeg, image/png, image/jpg, application/pdf"
                    :prepend-icon="''"
                    prepend-inner-icon="mdi-paperclip"
                    outlined
                    dense
                    clearable
                    hint="Formatos permitidos: JPG, PNG, PDF"
                    persistent-hint
                    :rules="[(v) => !!v || 'El comprobante adjunto es requerido']"
                    @change="onFileChange"></v-file-input>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" lg="5">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-img v-if="previsualizacion && esImagen" :src="previsualizacion" contain height="300px" />
                <iframe
                  v-else-if="previsualizacion && esPDF"
                  :src="previsualizacion"
                  height="300px"
                  style="border: none; width: 100%"></iframe>
                <v-icon v-else large color="grey lighten-1">mdi-image-broken-variant</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" type="button" :disabled="guardando" text @click="cerrar"> Cerrar </v-btn>
          <v-btn color="blue darken-1" type="submit" :disabled="guardando" :loading="guardando" text> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import comprobanteReversionService from '../services/comprobante-reversion';

export default {
  name: 'ModalRegistrarComprobanteReversion',
  computed: {
    maxFechaHora() {
      const hoy = new Date();
      return hoy.toISOString().slice(0, 16);
    },
    totalDetalles() {
      return this.detalles.reduce((s, d) => s + Number(d.importe || 0), 0).toFixed(2);
    },
  },
  data() {
    return {
      mostrado: false,
      detalles: [],
      importe: null,
      archivo: null,
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
      form: {
        detalles_solicitudes_ids: [],
        numero_comprobante: null,
        fecha_hora: null,
        archivo_comprobante: null,
      },
      guardando: false,
    };
  },
  methods: {
    abrir(detalles) {
      this.detalles = detalles;
      this.form.detalles_solicitudes_ids = detalles.map((d) => d.id);
      this.importe = null;
      this.form.numero_comprobante = null;
      this.form.fecha_hora = null;
      this.form.archivo_comprobante = null;
      this.archivo = null;
      this.previsualizacion = null;
      this.esImagen = false;
      this.esPDF = false;
      this.mostrado = true;
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },
    cerrar() {
      this.mostrado = false;
    },
    onFileChange() {
      if (this.archivo) {
        const reader = new FileReader();
        const fileType = this.archivo.type;

        reader.onload = (e) => {
          const result = e.target.result;
          this.form.archivo_comprobante = result.split(',')[1];

          if (fileType.includes('image')) {
            this.previsualizacion = result;
            this.esImagen = true;
            this.esPDF = false;
          } else if (fileType.includes('pdf')) {
            const blob = new Blob([this.archivo], { type: fileType });
            this.previsualizacion = URL.createObjectURL(blob);
            this.esImagen = false;
            this.esPDF = true;
          } else {
            this.previsualizacion = null;
            this.esImagen = false;
            this.esPDF = false;
          }
        };

        reader.readAsDataURL(this.archivo);
      } else {
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
        this.form.archivo_comprobante = null;
      }
    },
    async guardar() {
      if (!this.$refs.form.validate()) return;
      this.guardando = true;

      const payload = {
        ...this.form,
        fecha_hora: this.form.fecha_hora ? this.form.fecha_hora.replace('T', ' ') + ':00' : null,
      };

      try {
        const response = await comprobanteReversionService.create(payload);
        const data = response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje || 'Comprobante de reversión registrado correctamente',
          type: 'success',
        });

        this.cerrar();
        this.$emit('guardado');
      } catch (error) {
        window.console.error({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;
        const errores = data?.errores;
        const textoErrores = errores ? Object.values(errores).flat().join(' ') : null;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: textoErrores || mensaje || 'Ocurrió un error al registrar el comprobante de reversión',
          type: 'error',
        });
      }

      this.guardando = false;
    },
  },
};
</script>

<style scoped>
.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  height: 320px;
  max-height: 320px;
  background-color: #f5f5f5;
}
</style>
